// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"87":"eda82eb6","119":"ff78e0c7","168":"b170c5cb","450":"c03a6d8e","471":"dbf54689","607":"b07b7a51","698":"e466a664"}[chunkId] + ".js";
};